"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("@antv/util");
/**
 * 按照scale字段values中的start和end信息从全部数据中取出对应的部分
 *
 * @param field scale field
 * @param values scale values
 * @param data original data
 * @param range range start & end
 */
exports.getDataByScaleRange = function (field, values, data, _a, vertical) {
    var start = _a[0], end = _a[1];
    if (vertical === void 0) { vertical = false; }
    var groupedData = util_1.groupBy(data, field);
    var newValues = vertical ? values.slice(values.length - end, values.length - start) : values.slice(start, end);
    return util_1.flatten(util_1.map(newValues, function (value) { return groupedData[value] || []; }));
};
//# sourceMappingURL=data-range.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/interaction/helper/data-range.js
// module id = 612
// module chunks = 37